import { useState } from 'preact/hooks';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/Partners.module.css';
import whatsbeLogoBlack from '../../assets/images/partners/whatsbe_black.png';
import dlavorLogo from '../../assets/images/partners/Dlavor_logo.jpg';
import dlavorImage3 from '../../assets/images/partners/Dlavor_3.png';

const partners = [
  {
    id: 'whatsbe',
    name: '왓츠비',
    description: '센터의 매력을 \'한 편의 콘텐츠\'로\n왓츠비가 담고, 올림이 확산합니다.',
    logo: whatsbeLogoBlack,
    link: 'https://www.whatsb.co.kr/',
    flippable: false
  },
  {
    id: 'dlavor',
    name: 'Dlavor',
    description: 'For a more refined tennis experience',
    logo: dlavorLogo,
    link: null,
    flippable: true,
    backImage: dlavorImage3
  }
];

export default function Partners() {
  const [ref, isVisible] = useScrollAnimation({ once: true });
  const [flippedCards, setFlippedCards] = useState({});

  const handleCardClick = (partner) => {
    if (partner.link) {
      window.open(partner.link, '_blank', 'noopener,noreferrer');
    } else if (partner.flippable) {
      setFlippedCards(prev => ({
        ...prev,
        [partner.id]: !prev[partner.id]
      }));
    }
  };

  return (
    <section ref={ref} className={`section ${styles.partners}`}>
      <div className="section-content">
        <h2 className={`text-center ${styles.title}`}>
          올림 <span className={styles.highlight}>협력사</span>
        </h2>
        <p className={`text-center ${styles.subtitle}`}>
          함께 성장하는 파트너들을 소개합니다
        </p>

        <div className={`${styles.partnersGrid} ${isVisible ? styles.visible : ''}`}>
          {partners.map((partner, index) => (
            <div
              key={partner.id}
              className={`${styles.cardWrapper} ${partner.flippable ? styles.flippable : ''}`}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div
                className={`${styles.cardInner} ${flippedCards[partner.id] ? styles.flipped : ''}`}
                onClick={() => handleCardClick(partner)}
              >
                {/* 앞면 */}
                <div className={`${styles.partnerCard} ${styles.cardFront} ${partner.link || partner.flippable ? styles.clickable : ''}`}>
                  <div className={styles.logoContainer}>
                    <img src={partner.logo} alt={`${partner.name} 로고`} className={styles.logo} />
                  </div>
                  {partner.description && (
                    <p className={styles.partnerDescription}>{partner.description}</p>
                  )}
                  {partner.link && (
                    <div className={styles.linkIndicator}>
                      <span>사이트 방문 →</span>
                    </div>
                  )}
                </div>

                {/* 뒷면 (플립 가능한 카드만) */}
                {partner.flippable && (
                  <div className={`${styles.partnerCard} ${styles.cardBack}`}>
                    <img src={partner.backImage} alt={`${partner.name} 이미지`} className={styles.backImage} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
